import { ProseBlock, SectionHead } from "./shared";

// =========================================================================
// SPECIFICATIONS
// =========================================================================
export function SpecsTab({ d, narrativeLoading }) {
  const hasContent =
    d.narrative_study_specs?.length > 0 || d.study_specs?.trim();
  return (
    <div className="space-y-10" data-testid="specs-tab">
      <SectionHead n="01" title="Study Specifications" />
      {hasContent ? (
        <ProseBlock
          paragraphs={d.narrative_study_specs}
          fallback={d.study_specs}
        />
      ) : (
        <p
          className="text-sm text-stone-400 animate-pulse"
          data-testid="narrative-loading-specs"
        >
          {narrativeLoading ? "Loading study specifications…" : "No study specifications provided."}
        </p>
      )}
    </div>
  );
}
